import { useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { hasAnyRole, IDENTITY_ALERT_ROLES } from '@/shared/guards/roles';
import { useEffectiveRoles } from '@/shared/view-as/use-effective-roles';
import { UsersRepositoryToken } from '../../di/tokens';

/**
 * Os outros `User` com o mesmo CPF/CNPJ. Só dispara para quem tem
 * `IDENTITY_ALERT_ROLES` — o `iamEditor` também abre a página de detalhe, mas a
 * rota responde 403 para ele, e o gate aqui evita a chamada em vez de exibir o
 * erro. A autoridade é o `@Roles` do back.
 */
export function useUserDuplicateDocument(userId: string) {
  const canSee = hasAnyRole(useEffectiveRoles(), IDENTITY_ALERT_ROLES);
  const repository = container.resolve(UsersRepositoryToken);
  return useQuery({
    queryKey: ['users', userId, 'duplicate-document'],
    queryFn: () => repository.getDuplicateDocument(userId),
    staleTime: 1000 * 60 * 5,
    enabled: !!userId && canSee,
  });
}
